module.exports = __webpack_public_path__ + "img/live_footer_logo.ba7a7428.png";